'use client';

import { PropsWithChildren, createContext, useContext } from 'react';

const StorageKeyPrefixContext = createContext('');

export function useStorageKeyPrefix() {
  return useContext(StorageKeyPrefixContext);
}

interface Props {
  value: string;
}

export default function StorageKeyPrefixProvider({
  value,
  children,
}: PropsWithChildren<Props>) {
  return (
    <StorageKeyPrefixContext.Provider value={value}>
      {children}
    </StorageKeyPrefixContext.Provider>
  );
}
